<template>
  <a-modal visible :title="title" @cancel="cancel">
    <ak-inputs v-model="data" :options="options" ref="input" />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" @click="submit">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import store from '@/store'
export default {
  data () {
    return {
      oriWorkShop: '', // 原所属车间
      data: {
        name: '', // 大类名称
        workShop: '', // 所属车间
        parentNode: '', // 上级所属(所属车间)
        type: 'model', // 类型
        amountRatio2: '', // 系数
        profitRatio2: '' // 系数
      },
      options: [
        {
          name: 'name',
          note: '型号名称',
          type: 'String',
          validators: [
            (val) => val ? null : '型号名称不可为空'
          ]
        },
        {
          name: 'workShop',
          note: '所属车间',
          type: 'Pointer',
          targetClass: 'shopManagement',
          listWhere: (where) => {
            where.type = 'workShop'
            if (store.state.user && store.state.user.allShopManagements === 'No') {
              if (this.record) { // 编辑
                where.objectId.$in = store.state.user.shopManagements
              } else { // 新建
                where.objectId = { $in: store.state.user.shopManagements }
              }
            }
          },
          validators: [
            (val) => val ? null : '所属车间不可为空'
          ]
        },
        {
          name: 'amountRatio2',
          note: '大类吨系数',
          type: 'Number',
          validators: [
            (val) => val ? null : '大类吨系数不可为空'
          ]
        },
        {
          name: 'profitRatio2',
          note: '大类利系数',
          type: 'Number',
          validators: [
            (val) => val ? null : '大类利系数不可为空'
          ]
        }
      ]
    }
  },
  mounted () {
    if (this.record) { // 编辑
      console.log(this.record)
      if (this.record && this.record.name) { this.data.name = this.record.name }
      if (this.record && this.record.parentNode) { this.data.parentNode = this.record.parentNode.objectId }
      if (this.record && this.record.workShop) {
        this.data.workShop = this.record.workShop.objectId
        this.oriWorkShop = this.record.workShop.objectId
      }
      if (this.record && this.record.amountRatio2) { this.data.amountRatio2 = this.record.amountRatio2 }
      if (this.record && this.record.profitRatio2) { this.data.profitRatio2 = this.record.profitRatio2 }
    }
  },
  methods: {
    async submit () {
      // 验证必填项
      let error = await this.$refs.input.validate()
      this.data.amountRatio2 = parseFloat(this.data.amountRatio2)
      this.data.profitRatio2 = parseFloat(this.data.profitRatio2)
      this.data.parentNode = this.data.workShop
      if (Object.keys(error).length === 0) {
        if (!this.record) {
          let res = await this.$modelAjax.post('shopManagement', this.data).catch(e => {
            throw this.$notification['error']({
              message: '保存失败',
              description: '保存失败，请重新尝试'
            })
          })
          if (res) {
            this.$notification['success']({
              message: '保存成功',
              description: '数据已保存'
            })
          }
        }
        if (this.record) { // 编辑
          try {
            await this.$modelAjax.put('shopManagement', this.record.objectId, this.data)
            if (this.oriWorkShop !== this.data.workShop) {
              this.$tkParse.post('/parentNode/editModel', {
                objectId: this.record.objectId,
                workShop: this.data.workShop
              })
            }
            this.$notification['success']({
              message: '保存成功',
              description: '数据已保存'
            })
          } catch (error) {
            throw this.$notification['error']({
              message: '保存失败',
              description: '保存失败，请重新尝试'
            })
          }
        }
        this.vm.refresh()
        this.$emit('complete', 'cancel')
      }
    },
    cancel () {
      this.$emit('complete')
    }
  },
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String, // 假如当前model显示为category格式，则会将当前的值传入
    title: String
  }
}
</script>

<style>

</style>
